import React from 'react'

const MaterialSkeleton = () => {
    return (
        <div className="grid grid-cols-1 gap-4 mt-5">
            {[...Array(6)].map((_, index) => (
                <div key={index} className="bg-white flex gap-5 md:flex-col rounded-3xl p-4 shadow-sm animate-pulse">
                    {/* Image Skeleton */}
                    <div className=" w-[120px] h-[88px] md:mx-auto bg-gray-200 rounded-2xl mb-3"></div>
                    <div className='w-full'>
                        {/* Title Skeleton */}
                        <div className="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>

                        {/* Subject and Author Skeleton */}
                        <div className="flex items-center gap-2 mb-2">
                            <div className="h-4 bg-gray-200 rounded w-20"></div>
                            <div className="h-4 bg-gray-200 rounded w-4"></div>
                            <div className="h-4 bg-gray-200 rounded w-16"></div>
                        </div>

                        {/* Stats Skeleton */}
                        <div className="flex items-center justify-between mt-3">
                            <div className="flex items-center gap-2">
                                <div className="h-4 bg-gray-200 rounded w-16"></div>
                                <div className="h-4 bg-gray-200 rounded w-4"></div>
                                <div className="h-4 bg-gray-200 rounded w-16"></div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default MaterialSkeleton